export function getPublicDynamicPath() {
    return (process.env.IW_PDP && process.env.IW_PDP != "") ? '/' + process.env.IW_PDP : '';
}